module.exports = __webpack_public_path__ + "img/Weapon_191.e3185845.png";